/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import Swal from "sweetalert2";
import Switch from "react-switch";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import Pagenation from "../Layout/Pagenation";
import "react-datepicker/dist/react-datepicker.css";
// Scoped copy of employee.css: the original is a raw Tailwind build whose
// preflight reset (`* { border-width: 0; box-sizing: border-box; ... }`,
// `html { ... }`, etc.) is unscoped and would overwrite Bootstrap's own
// resets app-wide the moment it loaded, breaking every other existing page.
// Every selector in this copy is prefixed with .employee-view-scope so it
// only ever applies inside the wrapper div rendered below.
import "./employee.scoped.css";
// Must load after employee.scoped.css - restores Bootstrap .btn sizing that
// Tailwind's preflight reset (above) strips from every <button>.
import "./employee-bootstrap-compat.css";
import { GET_EMP_FORMPOST, GET_EMP_DETAILDATA } from "../../actions";
import empApi from "../../utils/employeeAxios";
import { Modal, Button } from "react-bootstrap";
import { format } from "date-fns";
import {
  showLoader,
  hideLoader,
  showAlert,
  showContaimerLoader,
  showStatus,
  encodeValue,
  removeEmpItem,
  hasPermission,
  showPageView,
  showDate,
} from "../Settings/Settings";
import { adminlimit, downloadUrl } from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "employee";
const moduleName = "Employee";
const moduleID = 34;
const titleList = [
  { label: "Dr", value: "Dr" },
  { label: "Miss", value: "Miss" },
  { label: "Mr", value: "Mr" },
  { label: "Mrs", value: "Mrs" },
  { label: "Ms", value: "Ms" },
  { label: "Shree", value: "Shree" },
  { label: "Shri", value: "Shri" },
  { label: "Smt", value: "Smt" },
  { label: "Other", value: "Other" },
];
const genderList = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];
const maleRelation = [
  { label: "Brother", value: "Brother" },
  { label: "Father", value: "Father" },
  { label: "FatherInLaw", value: "FatherInLaw" },
  { label: "GrandFather", value: "GrandFather" },
  { label: "Son", value: "Son" },
  { label: "Spouse", value: "Spouse" },
  { label: "Other", value: "Other" },
];
const femaleRelation = [
  { label: "Daughter", value: "Daughter" },
  { label: "GrandMother", value: "GrandMother" },
  { label: "Mother", value: "Mother" },
  { label: "MotherInLaw", value: "MotherInLaw" },
  { label: "Sister", value: "Sister" },
  { label: "Spouse", value: "Spouse" },
  { label: "Other", value: "Other" },
];
const otherRelation = [
  { label: "Brother", value: "Brother" },
  { label: "Father", value: "Father" },
  { label: "FatherInLaw", value: "FatherInLaw" },
  { label: "GrandFather", value: "GrandFather" },
  { label: "Son", value: "Son" },
  { label: "Spouse", value: "Spouse" },
  { label: "Daughter", value: "Daughter" },
  { label: "GrandMother", value: "GrandMother" },
  { label: "Mother", value: "Mother" },
  { label: "MotherInLaw", value: "MotherInLaw" },
  { label: "Sister", value: "Sister" },
  { label: "Other", value: "Other" },
];
const bloodGroup = [
  { label: "A-", value: "A-" },
  { label: "A+", value: "A+" },
  { label: "A1-", value: "A1-" },
  { label: "A1+", value: "A1+" },
  { label: "A1B-", value: "A1B-" },
  { label: "A1B+", value: "A1B+" },
  { label: "A2-", value: "A2-" },
  { label: "A2+", value: "A2+" },
  { label: "A2B-", value: "A2B-" },
  { label: "A2B+", value: "A2B+" },
  { label: "AB-", value: "AB-" },
  { label: "AB+", value: "AB+" },
  { label: "B-", value: "B-" },
  { label: "B+", value: "B+" },
  { label: "B1-", value: "B1-" },
  { label: "B1+", value: "B1+" },
  { label: "NA", value: "NA" },
  { label: "O-", value: "O-" },
  { label: "O+", value: "O+" },
];
const maritalStatus = [
  { label: "Unmarried", value: "Unmarried" },
  { label: "Married", value: "Married" },
  { label: "Widow", value: "Widow" },
  { label: "Widower", value: "Widower" },
  { label: "Divorced", value: "Divorced" },
  { label: "Separated", value: "Separated" },
];
const nationalityList = [
  { label: "Indian", value: "Indian" },
  { label: "Afarican", value: "Afarican" },
  { label: "American", value: "American" },
];
const religionList = [
  { label: "Christianity", value: "Christianity" },
  { label: "Islam", value: "Islam" },
  { label: "Hinduism", value: "Hinduism" },
  { label: "Buddhism", value: "Buddhism" },
  { label: "Sikhism", value: "Sikhism" },
  { label: "Judaism", value: "Judaism" },
  { label: "Baháʼí Faith", value: "Baháʼí Faith" },
  { label: "Jainism", value: "Jainism" },
  { label: "Shintoism", value: "Shintoism" },
  { label: "Zoroastrianism", value: "Zoroastrianism" },
];
const salarypay = [
  { label: "Monthly", value: "M" },
  { label: "Yearly", value: "Y" },
];

const financialYearList = [];
const currentDate = new Date();
const start = currentDate.getFullYear();
const end = 2000;
for (let i = start; i >= end; i--) {
  financialYearList.push({
    label: `${i}-${parseInt(i) + 1}`,
    value: `${i}-${parseInt(i) + 1}`,
  });
}

class ViewDetails extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.match.params?.editID ?? "";
    this.state = {
      editID: editID,
      postdata: {},
      detaildata: [],
      designationList: [],
      departmentList: [],

      error_msg: "",
      pageloading: false,
      activeTab: "about",

      showPastCompany: false,

      pastCompanycurrentPage: 1,
      pastCompanyloading: true,
      pastCompanytotalRecords: 0,
      pastCompanytotalPage: 0,
      pastEmploymentList: [],

      showdocumentPopup: false,
      documentcurrentPage: 1,
      documentloading: true,
      documenttotalRecords: 0,
      documenttotalPage: 0,
      documentList: [],
      docTypeList: [],
      docID: "",
      docTypeID: "",
      docNumber: "",
      docName: "",
      docIssuePlace: "",
      docIssueDate: "",
      docExpiryDate: "",
      docFile: "",

      showSalaryPopup: false,
      salaryAffectedDate:"",
      salaryID:"",
      salaryDetails: {
        subtotal:0,
        grosssalary:0,
        ctctotal: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        gratuityamountmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        basicsalary: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        consultancyfees: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        contractfee: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        conveyanceallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        da: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        educationallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        foodallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        houserentallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        leavetravelallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        medicalallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        otherallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        specialallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        stipend: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        esiemployeecontributionmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        lwfmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        tdsmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        nonstatutorydeduction: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        otherdeduction: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        salaryadvance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        companycontribution: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        employeeesictc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        employeepfctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
          manualedit: false,
        },
        employeresictc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
          manualedit: false,
        },
        employeepfadminchargescrc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        cmployerpfctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        gratuitycontributionctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        netpayctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
          manualedit: false,
        },
        proftaxctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        bonusprevision: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
      },

      showpersonalInformationPopup: false,
      /* fatherName: "",
      MotherName: "",
      maritalStatus: "",
      marriageDate: "",
      personalEmailId: "",
      nomineeEmail: "",
      religion: "",
      nationality: "",
      countryOfBirth: "",
      stateOfBirth: "",
      placeOfBirth: "",
      physicalDisabilities: "",
      disabilityRemark: "",
      identificationMark1: "",
      identificationMark2: "",
      extraCurricularInterest: "", */

      companyName: "",
      leavingDate: "",
      typeOfBusiness: "",
      JoiningDate: "",
      reportingToDesignation: "",
      department: "",
      designationJoining: "",
      designationLeaving: "",
      leavingReason: "",
      responsibilities: "",
      companyAddress: "",
      achievements: "",
      financialYear: "",
      lastSalaryDrawn: "",
      PFOfficeName: "",
      PFNumber: "",
      PFAmountTransfered: "",
      incomeAfterExemption: "",
      US80CBenefitClaimed: "",
      standardDeductionBenefitClaimed: "",
      professionalTax: "",
      TDSTaxPaid: "",
      rawTax: "",
      surcharge: "",
      cess: "",
      prevcompanyattachment: "",
      removeprevcompanyattachment: "",
      prevCompID: "",
      industryList: [],

      familycurrentPage: 1,
      familytotalRecords: 0,
      familytotalPage: 0,
      familyloading: false,
      familyList: [],

      showFamilyPopup: false,
      familyIsDependent: false,
      familyTitle: "",
      familyName: "",
      familyGender: "",
      familyRelation: "",
      familyAddress: "",
      familyBloodGroup: "",
      familyContactNo: "",
      familyDOB: "",
      familyMaritalStatus: "",
      familyMarriageDate: "",
      familyEmployment: "",
      familyProfession: "",
      familyNationality: "",
      familyInsuranceNumber: "",
      familyRemarks: "",
      familyID: "",

      showSkillSetPopup: false,
      skillList: "",

      skillSetList: [],
      skillSetcurrentPage: 1,
      skillSettotalRecords: 0,
      skillSettotalPage: 0,
      skillSetloading: false,

      empskillsetID: "",
      empskillID: "",
      empskillsetType: "",
      empskillsetLevel: "",
      empskillsetWEF: "",

      showLanguagePopup: false,
      languageList: "",
      employeelanguageList: [],
      employeelanguagecurrentPage: 1,
      employeelanguagetotalRecords: 0,
      employeelanguagetotalPage: 0,
      employeelanguageloading: false,
      emplanguageID: "",
      languageID: "",
      emplanguageMotherTongue: false,
      emplanguageSpeak: false,
      emplanguageRead: false,
      emplanguageWrite: false,

      showMiscellaneousPopup: false,
      Height: "",
      Weight: "",
      BloodGroup: "",
      ShoeSize: "",
      ShirtSize: "",
      TShirtSize: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
      return;
    }
    console.log(this.state.editID, "this.state.editID");
    this.loadDesignation();
    this.loadDepartment();
    this.loadIndustry();
    this.getPastCompanyList(1);
    this.getFamilyList(1);
    this.loadDetails();
    this.loadDocTypeList();
    this.getdocumentList(1);
    this.loadSkill();
    this.getSkillSetList(1);
    this.loadLanguage();
    this.getemployeelanguageList(1);
  }

  loadDetails() {
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${module}/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/hrms/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].success === true) {
          var result = nextProps.detaildata[0].result;
          this.setState({ pageloading: false, postdata: result }, () => {
            const miscellaneousID =
              this.state.postdata?.miscellaneous?.miscellaneousID ?? "";
            if (miscellaneousID) {
              let miscellaneousData = { ...this.state.postdata.miscellaneous };
              miscellaneousData.BloodGroup =
                miscellaneousData.BloodGroup !== ""
                  ? {
                      label: miscellaneousData.BloodGroup,
                      value: miscellaneousData.BloodGroup,
                    }
                  : "";
              let salary = { ...this.state.postdata.salary };
              this.setState({
                ...miscellaneousData,
                ...salary,
              });
            }
          });
        } else {
          this.props.history.push("/hrms/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value, addParam) => {
    console.log(field, value, addParam, "addParamaddParamaddParam");
    if (field === "page") {
      if (addParam === "pastcompany") {
        this.setState(
          {
            pastCompanyloading: true,
            pastCompanycurrentPage: value,
          },
          () => {
            this.getPastCompanyList(value);
          }
        );
      } else if (addParam === "family") {
        this.setState(
          {
            familyloading: true,
            familycurrentPage: value,
          },
          () => {
            this.getFamilyList(value);
          }
        );
      } else if (addParam === "document") {
        this.setState(
          {
            documentloading: true,
            documentcurrentPage: value,
          },
          () => {
            this.getdocumentList(value);
          }
        );
      } else if (addParam === "skillSet") {
        this.setState(
          {
            skillSetloading: true,
            skillSetcurrentPage: value,
          },
          () => {
            this.getSkillSetList(value);
          }
        );
      } else if (addParam === "employeelanguage") {
        this.setState(
          {
            employeelanguageloading: true,
            employeelanguagecurrentPage: value,
          },
          () => {
            this.getemployeelanguageList(value);
          }
        );
      }
    }
  };

  loadDesignation() {
    var urlShringTxt = `${module}/designation/dropdown`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ designationList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadDepartment() {
    const urlShringTxt = `${module}/department/dropdown`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ departmentList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  loadIndustry() {
    const urlShringTxt = `${module}/industry/dropdown`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ industryList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleChange(checked, name) {
    this.setState({ checked });
  }
  handleChangeText(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handleChangeCheckbox(e) {
    this.setState({ [e.target.name]: e.target.checked });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleSelectSalaryChange(MainName, subName, value) {
    this.setState((prevState) => {
      const salaryDetails = { ...prevState.salaryDetails };

      // Ensure nested objects are also copied
      salaryDetails[MainName] = {
        ...salaryDetails[MainName],
        [subName]: value,
      };

      return { salaryDetails };
    }, ()=> {
      this.calculateSalary();
    });
  }
  handleChangeTextSalary(MainName, subName, e) {
    this.setState((prevState) => {
      const salaryDetails = { ...prevState.salaryDetails };

      // Ensure nested objects are also copied
      salaryDetails[MainName] = {
        ...salaryDetails[MainName],
        [subName]: e.target.value,
      };

      return { salaryDetails };
    }, ()=> {
      this.calculateSalary();
    });
  }
  handleSwitchSalary(MainName, subName, value) {
    this.setState((prevState) => {
      const salaryDetails = { ...prevState.salaryDetails };

      // Ensure nested objects are also copied
      salaryDetails[MainName] = {
        ...salaryDetails[MainName],
        [subName]: value,
      };

      return { salaryDetails };
    }, ()=> {
      this.calculateSalary();
    });
  }
  calculateSalary = () => {
    const salaryDetails = this.state.salaryDetails;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const consultancyfees = salaryDetails.consultancyfees.amount || 0;
    const contractfee = salaryDetails.contractfee.amount || 0;
    const conveyanceallowance = salaryDetails.conveyanceallowance.amount || 0;
    const da = salaryDetails.da.amount || 0;
    const educationallowance = salaryDetails.educationallowance.amount || 0;
    const foodallowance = salaryDetails.foodallowance.amount || 0;
    const houserentallowance = salaryDetails.houserentallowance.amount || 0;
    const leavetravelallowance = salaryDetails.leavetravelallowance.amount || 0;
    const medicalallowance = salaryDetails.medicalallowance.amount || 0;
    const otherallowance = salaryDetails.otherallowance.amount || 0;
    const specialallowance = salaryDetails.specialallowance.amount || 0;
    const stipend = salaryDetails.stipend.amount || 0;
    /* const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0;
    const basicsalary = salaryDetails.basicsalary.amount || 0; */

    console.log(basicsalary);
    /* salaryDetails: {
        subtotal:0,
        grosssalary:0,
        ctctotal: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        gratuityamountmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        basicsalary: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        consultancyfees: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        contractfee: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        conveyanceallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        da: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        educationallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        foodallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        houserentallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        leavetravelallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        medicalallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        otherallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        specialallowance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        stipend: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        esiemployeecontributionmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        lwfmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        tdsmanual: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        nonstatutorydeduction: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        otherdeduction: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        salaryadvance: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        companycontribution: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        employeeesictc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        employeepfctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
          manualedit: false,
        },
        employeresictc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
          manualedit: false,
        },
        employeepfadminchargescrc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        cmployerpfctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        gratuitycontributionctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        netpayctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
          manualedit: false,
        },
        proftaxctc: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
        bonusprevision: {
          paybasics: { label: "Monthly", value: "M" },
          amount: "",
          remarks: "",
        },
      }, */

  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };
  selectTab(activeTab) {
    this.setState({ activeTab });
  }
  openPopup(name, show) {
    this.setState({ [name]: show });
  }
  getPastCompanyList(offset) {
    const urlShringTxt = `${module}/prevcompany?employeeID=${this.state.editID}&limit=${adminlimit}&${offset}`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({
            pastEmploymentList: res.data.result,
            pastCompanytotalRecords: res.data.totalRecords,
            pastCompanytotalPage: res.data.totalPage,
            pastCompanyloading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ pastCompanyloading: false });
        console.log(e);
      });
  }
  savePastCompany() {
    const postObject = {
      empID: this.state.editID,
      companyName: this.state.companyName,
      leavingDate:
        this.state.leavingDate !== ""
          ? format(new Date(this.state.leavingDate), "yyyy-MM-dd")
          : "",
      typeOfBusiness: this.state.typeOfBusiness?.value ?? "",
      JoiningDate:
        this.state.JoiningDate !== ""
          ? format(new Date(this.state.JoiningDate), "yyyy-MM-dd")
          : "",
      reportingToDesignation: this.state.reportingToDesignation,
      department: this.state.department,
      designationJoining: this.state.designationJoining,
      designationLeaving: this.state.designationLeaving,
      leavingReason: this.state.leavingReason,
      responsibilities: this.state.responsibilities,
      companyAddress: this.state.companyAddress,
      achievements: this.state.achievements,
      financialYear: this.state.financialYear?.value ?? "",
      lastSalaryDrawn: this.state.lastSalaryDrawn,
      PFOfficeName: this.state.PFOfficeName,
      PFNumber: this.state.PFNumber,
      PFAmountTransfered: this.state.PFAmountTransfered,
      incomeAfterExemption: this.state.incomeAfterExemption,
      US80CBenefitClaimed: this.state.US80CBenefitClaimed,
      standardDeductionBenefitClaimed:
        this.state.standardDeductionBenefitClaimed,
      professionalTax: this.state.professionalTax,
      TDSTaxPaid: this.state.TDSTaxPaid,
      rawTax: this.state.rawTax,
      surcharge: this.state.surcharge,
      cess: this.state.cess,
      removeprevcompanyattachment: this.state.removeprevcompanyattachment,
    };
    const formData = new FormData();

    // 🔁 Automatically append all fields from postdata
    Object.entries(postObject).forEach(([key, value]) => {
      formData.append(key, value);
    });
    const fileInput = document.getElementById("prevcompanyattachment");
    const file = fileInput.files[0]; // for single file

    if (file) {
      formData.append("attachment", file);
    }

    if (this.state.prevCompID !== "") {
      empApi.put(`${module}/prevcompany/${encodeValue(
            this.state.prevCompID
          )}`,
          formData)
        .then((res) => {
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.openPopup("showPastCompany", false);
            this.getPastCompanyList(1);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    } else {
      empApi.post(`${module}/prevcompany/create`, formData)
        .then((res) => {
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.getPastCompanyList(1);
            this.openPopup("showPastCompany", false);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  }
  editPasEmployment(item) {
    this.setState(
      {
        companyName: item.companyName,
        leavingDate:
          item.leavingDate !== "" && item.leavingDate !== null
            ? new Date(item.leavingDate)
            : "",
        typeOfBusiness:
          item.typeOfBusiness !== "" && item.typeOfBusiness !== null
            ? { label: item.industryName, value: item.typeOfBusiness }
            : "",
        JoiningDate:
          item.JoiningDate !== "" && item.JoiningDate !== null
            ? new Date(item.JoiningDate)
            : "",
        reportingToDesignation: item.reportingToDesignation,
        department: item.department,
        designationJoining: item.designationJoining,
        designationLeaving: item.designationLeaving,
        leavingReason: item.leavingReason,
        responsibilities: item.responsibilities,
        companyAddress: item.companyAddress,
        achievements: item.achievements,
        financialYear: item.financialYear?.value ?? "",
        lastSalaryDrawn: item.lastSalaryDrawn,
        PFOfficeName: item.PFOfficeName,
        PFNumber: item.PFNumber,
        PFAmountTransfered: item.PFAmountTransfered,
        incomeAfterExemption: item.incomeAfterExemption,
        US80CBenefitClaimed: item.US80CBenefitClaimed,
        standardDeductionBenefitClaimed: item.standardDeductionBenefitClaimed,
        professionalTax: item.professionalTax,
        TDSTaxPaid: item.TDSTaxPaid,
        rawTax: item.rawTax,
        surcharge: item.surcharge,
        cess: item.cess,
        prevcompanyattachment: item.attachment,
        prevCompID: item.prevCompID,
      },
      () => {
        this.openPopup("showPastCompany", true);
      }
    );
  }

  getFamilyList(offset) {
    const urlShringTxt = `${module}/family?employeeID=${this.state.editID}&limit=${adminlimit}&${offset}`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({
            familyList: res.data.result,
            familytotalRecords: res.data.totalRecords,
            familytotalPage: res.data.totalPage,
            familyloading: false,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({
          familyList: [],
          familytotalRecords: 0,
          familytotalPage: 0,
          familyloading: false,
        });
      });
  }
  saveFamilyInfo() {
    const postObject = {
      empID: this.state.editID,
      familyIsDependent: this.state.familyIsDependent ? "Yes" : "No",
      familyTitle: this.state.familyTitle?.value ?? "",
      familyName: this.state.familyName,
      familyGender: this.state.familyGender?.value ?? "",
      familyRelation: this.state.familyRelation?.value ?? "",
      familyAddress: this.state.familyAddress,
      familyBloodGroup: this.state.familyBloodGroup?.value ?? "",
      familyContactNo: this.state.familyAddress,
      familyDOB:
        this.state.familyDOB !== ""
          ? format(new Date(this.state.familyDOB), "yyyy-MM-dd")
          : "",
      familyMaritalStatus: this.state.familyMaritalStatus?.value ?? "",
      familyMarriageDate:
        this.state.familyMarriageDate !== ""
          ? format(new Date(this.state.familyMarriageDate), "yyyy-MM-dd")
          : "",
      familyEmployment: this.state.familyEmployment?.value ?? "",
      familyProfession: this.state.familyAddress,
      familyNationality: this.state.familyNationality?.value ?? "",
      familyInsuranceNumber: this.state.familyAddress,
      familyRemarks: this.state.familyAddress,
    };
    if (this.state.familyID !== "") {
      empApi.put(`${module}/family/${encodeValue(this.state.familyID)}`,
          postObject)
        .then((res) => {
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.openPopup("showFamilyPopup", false);
            this.getFamilyList(1);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    } else {
      empApi.post(`${module}/family/create`, postObject)
        .then((res) => {
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.getFamilyList(1);
            this.openPopup("showFamilyPopup", false);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  }
  editFamilyInfo(item) {
    this.setState(
      {
        familyIsDependent: item.familyIsDependent === "Yes" ? true : false,
        familyTitle:
          item.familyTitle !== "" && item.familyTitle !== null
            ? { label: item.familyTitle, value: item.familyTitle }
            : "",
        familyName: item.familyName,
        familyGender:
          item.familyGender !== "" && item.familyGender !== null
            ? { label: item.familyGender, value: item.familyGender }
            : "",
        familyRelation:
          item.familyRelation !== "" && item.familyRelation !== null
            ? { label: item.familyRelation, value: item.familyRelation }
            : "",
        familyAddress: item.familyAddress,
        familyBloodGroup:
          item.familyBloodGroup !== "" && item.familyBloodGroup !== null
            ? { label: item.familyBloodGroup, value: item.familyBloodGroup }
            : "",
        familyContactNo: item.familyContactNo,
        familyDOB:
          item.familyDOB !== "" && item.familyDOB !== null
            ? new Date(item.familyDOB)
            : "",
        familyMaritalStatus:
          item.familyMaritalStatus !== "" && item.familyMaritalStatus !== null
            ? {
                label: item.familyMaritalStatus,
                value: item.familyMaritalStatus,
              }
            : "",
        familyMarriageDate:
          item.familyMarriageDate !== "" && item.familyMarriageDate !== null
            ? new Date(item.familyMarriageDate)
            : "",
        familyEmployment:
          item.familyEmployment !== "" && item.familyEmployment !== null
            ? { label: item.familyEmployment, value: item.familyEmployment }
            : "",
        familyProfession: item.familyProfession,
        familyNationality:
          item.familyNationality !== "" && item.familyNationality !== null
            ? { label: item.familyNationality, value: item.familyNationality }
            : "",
        familyInsuranceNumber: item.familyInsuranceNumber,
        familyRemarks: item.familyRemarks,
        familyID: item.familyID,
      },
      () => {
        this.openPopup("showFamilyPopup", true);
      }
    );
  }

  loadDocTypeList() {
    const urlShringTxt = `${module}/doctype/dropdown`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ docTypeList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getdocumentList(offset) {
    const urlShringTxt = `${module}/document?employeeID=${this.state.editID}&limit=${adminlimit}&${offset}`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({
            documentList: res.data.result,
            documenttotalRecords: res.data.totalRecords,
            documenttotalPage: res.data.totalPage,
            documentloading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ documentloading: false });
        console.log(e);
      });
  }
  savedocument() {
    const postObject = {
      empID: this.state.editID,
      docTypeID: this.state.docTypeID?.value ?? "",
      docNumber: this.state.docNumber,
      docName: this.state.docName,
      docIssuePlace: this.state.docIssuePlace,
      docIssueDate:
        this.state.docIssueDate !== ""
          ? format(new Date(this.state.docIssueDate), "yyyy-MM-dd")
          : "",
      docExpiryDate:
        this.state.docExpiryDate !== ""
          ? format(new Date(this.state.docExpiryDate), "yyyy-MM-dd")
          : "",
      docFile: "",
    };
    showLoader("savedocument");
    if (this.state.docID !== "") {
      empApi.put(`${module}/document/${encodeValue(this.state.docID)}`,
          postObject)
        .then((res) => {
          hideLoader("savedocument");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.openPopup("showdocumentPopup", false);
            this.getdocumentList(1);
            this.setState({ docID: "" });
          }
        })
        .catch((e) => {
          this.setState({ docID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    } else {
      empApi.post(`${module}/document/create`, postObject)
        .then((res) => {
          hideLoader("savedocument");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            this.setState({ docID: "" });
            showAlert("Success", successMsg, "success", "No");
            this.getdocumentList(1);
            this.openPopup("showdocumentPopup", false);
          }
        })
        .catch((e) => {
          hideLoader("savedocument");
          this.setState({ docID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  }
  editdocument(item) {
    this.setState(
      {
        docTypeID:
          item.docTypeID !== ""
            ? { label: item.empdoctypeName, value: item.docTypeID }
            : "",
        docNumber: item.docNumber,
        docName: item.docName,
        docIssuePlace: item.docIssuePlace,
        docIssueDate:
          item.docIssueDate !== "" ? new Date(item.docIssueDate) : "",
        docExpiryDate:
          item.docExpiryDate !== "" ? new Date(item.docExpiryDate) : "",
        docFile: "",
        docID: item.docID,
      },
      () => {
        this.openPopup("showdocumentPopup", true);
      }
    );
  }

  saveMiscellaneous() {
    const postObject = {
      empID: this.state.editID,
      Height: this.state.Height,
      Weight: this.state.Weight,
      BloodGroup: this.state.BloodGroup?.value ?? "",
      ShoeSize: this.state.ShoeSize,
      ShirtSize: this.state.ShirtSize,
      TShirtSize: this.state.TShirtSize,
    };

    empApi.put(`${module}/updatemiscellaneous`, postObject)
      .then((res) => {
        if (res.data.success === true) {
          var successMsg = res.data.message;
          showAlert("Success", successMsg, "success", "No");
          this.openPopup("showMiscellaneousPopup", false);
          this.loadDetails();
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        showAlert("Error", errorMsg, "error", "No");
      });
  }

  
  saveSalary() {
    const postObject = {
      empID: this.state.editID,
    };


    if (this.state.salaryID !== "") {
      empApi.put(`${module}/employeesalery/${encodeValue(
            this.state.salaryID
          )}`,
          postObject)
        .then((res) => {
          hideLoader("savesalary");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.openPopup("showSalaryPopup", false);
            this.getsalaryList(1);
            this.restSkillSet();
            this.setState({ salaryID: "" });
          }
        })
        .catch((e) => {
          this.setState({ salaryID: "" });
          hideLoader("savesalary");
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    } else {
      empApi.post(`${module}/skillset/create`, postObject)
        .then((res) => {
          hideLoader("savesalary");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            this.setState({ salaryID: "" });
            showAlert("Success", successMsg, "success", "No");
            this.getSkillSetList(1);
            this.restSkillSet();
            this.openPopup("showSalaryPopup", false);
          }
        })
        .catch((e) => {
          hideLoader("savesalary");
          this.setState({ empskillsetID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }


    empApi.put(`${module}/updatesalary`, postObject)
      .then((res) => {
        if (res.data.success === true) {
          var successMsg = res.data.message;
          showAlert("Success", successMsg, "success", "No");
          this.openPopup("showSalaryPopup", false);
          this.loadDetails();
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        showAlert("Error", errorMsg, "error", "No");
      });
  }

  savePersonalinfo() {
    const postObject = {
      empID: this.state.editID,
      fatherName: this.state.fatherName,
      MotherName: this.state.MotherName,
      maritalStatus: this.state.maritalStatus?.value ?? "",
      marriageDate:
        this.state.marriageDate !== ""
          ? format(new Date(this.state.marriageDate), "yyyy-MM-dd")
          : "",
      personalEmailId: this.state.personalEmailId,
      nomineeEmail: this.state.nomineeEmail,
      religion: this.state.religion?.value ?? "",
      nationality: this.state.nationality?.value ?? "",
      countryOfBirth: this.state.countryOfBirth,
      stateOfBirth: this.state.stateOfBirth,
      placeOfBirth: this.state.placeOfBirth,
      physicalDisabilities:
        this.state.physicalDisabilities === true ? "Yes" : "No",
      disabilityRemark: this.state.disabilityRemark,
      identificationMark1: this.state.identificationMark1,
      identificationMark2: this.state.identificationMark2,
      extraCurricularInterest: this.state.extraCurricularInterest,
    };

    empApi.put(`${module}/updatePersonalinfo`, postObject)
      .then((res) => {
        if (res.data.success === true) {
          var successMsg = res.data.message;
          showAlert("Success", successMsg, "success", "No");
          this.openPopup("showpersonalInformationPopup", false);
          this.loadDetails();
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        showAlert("Error", errorMsg, "error", "No");
      });
  }

  getSkillSetList(offset) {
    const urlShringTxt = `${module}/skillset?employeeID=${this.state.editID}&limit=${adminlimit}&${offset}`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({
            skillSetList: res.data.result,
            skillSettotalRecords: res.data.totalRecords,
            skillSettotalPage: res.data.totalPage,
            skillSetloading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ skillSetloading: false });
        console.log(e);
      });
  }

  loadSkill() {
    const urlShringTxt = `${module}/skill/dropdown`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ skillList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  saveSkill() {
    const postObject = {
      empID: this.state.editID,
      empskillID: this.state.empskillID?.value ?? "",
      empskillsetType: this.state.empskillsetType?.value ?? "",
      empskillsetLevel: this.state.empskillsetLevel?.value ?? "",
      empskillsetWEF:
        this.state.empskillsetWEF !== ""
          ? format(new Date(this.state.empskillsetWEF), "yyyy-MM-dd")
          : "",
    };
    showLoader("saveSkillSet");
    if (this.state.empskillsetID !== "") {
      empApi.put(`${module}/skillset/${encodeValue(
            this.state.empskillsetID
          )}`,
          postObject)
        .then((res) => {
          hideLoader("saveSkillSet");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.openPopup("showSkillSetPopup", false);
            this.getSkillSetList(1);
            this.restSkillSet();
            this.setState({ docID: "" });
          }
        })
        .catch((e) => {
          this.setState({ docID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    } else {
      empApi.post(`${module}/skillset/create`, postObject)
        .then((res) => {
          hideLoader("saveSkillSet");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            this.setState({ docID: "" });
            showAlert("Success", successMsg, "success", "No");
            this.getSkillSetList(1);
            this.restSkillSet();
            this.openPopup("showSkillSetPopup", false);
          }
        })
        .catch((e) => {
          hideLoader("saveSkillSet");
          this.setState({ empskillsetID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  }

  editSkillSet(skill) {
    this.setState(
      {
        empskillsetID: skill.empskillsetID,
        empskillID:
          skill.empskillID !== ""
            ? { value: skill.empskillID, label: skill.empskillName }
            : "",
        empskillsetType:
          skill.empskillsetType !== ""
            ? { value: skill.empskillsetType, label: skill.empskillsetType }
            : "",
        empskillsetLevel:
          skill.empskillsetLevel !== ""
            ? {
                value: skill.empskillsetLevel,
                label: `Level${skill.empskillsetLevel}`,
              }
            : "",
        empskillsetWEF:
          skill.empskillsetWEF !== "" ? new Date(skill.empskillsetWEF) : "",
      },
      () => {
        this.openPopup("showSkillSetPopup", true);
      }
    );
  }

  restSkillSet() {
    this.setState({
      empskillsetID: "",
      empskillID: "",
      empskillsetType: "",
      empskillsetLevel: "",
      empskillsetWEF: "",
    });
  }

  loadLanguage() {
    const urlShringTxt = `${module}/language/dropdown`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({ languageList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getemployeelanguageList(offset) {
    const urlShringTxt = `${module}/employeelanguage?employeeID=${this.state.editID}&limit=${adminlimit}&${offset}`;
    empApi.get(urlShringTxt)
      .then((res) => {
        if (res.data.success === true) {
          this.setState({
            employeelanguageList: res.data.result,
            employeelanguagetotalRecords: res.data.totalRecords,
            employeelanguagetotalPage: res.data.totalPage,
            employeelanguageloading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ employeelanguageloading: false });
        console.log(e);
      });
  }

  saveLanguage() {
    const postObject = {
      empID: this.state.editID,
      languageID: this.state.languageID?.value ?? "",
      emplanguageMotherTongue:
        this.state.emplanguageMotherTongue === true ? "Y" : "N",
      emplanguageSpeak: this.state.emplanguageSpeak === true ? "Y" : "N",
      emplanguageRead: this.state.emplanguageRead === true ? "Y" : "N",
      emplanguageWrite: this.state.emplanguageWrite === true ? "Y" : "N",
    };
    showLoader("saveLanguage");
    if (this.state.emplanguageID !== "") {
      empApi.put(`${module}/employeelanguage/${encodeValue(
            this.state.emplanguageID
          )}`,
          postObject)
        .then((res) => {
          hideLoader("saveLanguage");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            showAlert("Success", successMsg, "success", "No");
            this.openPopup("showLanguagePopup", false);
            this.getemployeelanguageList(1);
            this.restemployeelanguage();
            this.setState({ docID: "" });
          }
        })
        .catch((e) => {
          this.setState({ docID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    } else {
      empApi.post(`${module}/employeelanguage/create`, postObject)
        .then((res) => {
          hideLoader("saveLanguage");
          if (res.data.success === true) {
            var successMsg = res.data.message;
            this.setState({ docID: "" });
            showAlert("Success", successMsg, "success", "No");
            this.getemployeelanguageList(1);
            this.restemployeelanguage();
            this.openPopup("showLanguagePopup", false);
          }
        })
        .catch((e) => {
          hideLoader("saveLanguage");
          this.setState({ emplanguageID: "" });
          var errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  }

  editemployeelanguage(editData) {
    this.setState(
      {
        emplanguageID: editData.emplanguageID,
        languageID:
          editData.languageID !== ""
            ? { value: editData.languageID, label: editData.languageName }
            : "",
        emplanguageMotherTongue:
          editData.emplanguageMotherTongue === "Y" ? true : false,
        emplanguageSpeak: editData.emplanguageSpeak === "Y" ? true : false,
        emplanguageRead: editData.emplanguageRead === "Y" ? true : false,
        emplanguageWrite: editData.emplanguageWrite === "Y" ? true : false,
      },
      () => {
        this.openPopup("showLanguagePopup", true);
      }
    );
  }

  restemployeelanguage() {
    this.setState({
      emplanguageID: "",
      languageID: "",
      emplanguageMotherTongue: false,
      emplanguageSpeak: false,
      emplanguageRead: false,
      emplanguageWrite: false,
    });
  }

  removeItem(deleteID, deleteModule, currentPage, sateData) {
    const delurl = `${module}/${deleteModule}`;
    removeEmpItem(deleteID, delurl, this.sateValChange, currentPage, sateData);
  }
  generateLetter(type) {
    showLoader(type);
    let generateURL = "";
    if (type === "AppointmentLetter") {
      generateURL = "generateAppointmentLetter";
    } else if (type === "Confidentiality") {
      generateURL = "generateConfidentiality";
    } else if (type === "ConfirmationLetter") {
      generateURL = "generateConfirmationLetter";
    } else if (type === "OfferLetter") {
      generateURL = "generateOfferLetter";
    }
    const urlShringTxt = `${module}/${generateURL}`;
    const postObject = {
      employeeID: this.state.editID,
    };
    empApi.post(urlShringTxt, postObject)
      .then((res) => {
        hideLoader(type);
        if (res.data.status === "ok") {
          const a = document.createElement("a");
          a.href = `${downloadUrl}employeedoc/${res.data.fileName}`;
          a.download = res.data.fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((e) => {
        console.log(e);
        hideLoader(type);
      });
  }

  handleImageChange = (name, event) => {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      const imageUrl = URL.createObjectURL(file); // Create a URL for the selected file
      this.props.onChange("empPhoto", imageUrl);
    }
  };
  removeAttach(attachType) {
    const this_ = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You want remove this attachment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        try {
          if (attachType === "prevcompany") {
            this_.setState({
              prevcompanyattachment: "",
              removeprevcompanyattachment: "Yes",
            });
          }
          /*  return Axios.delete(
                  `${delUrl}/${formPayload}`,             
                  {
                    headers: {
                      Authorization: `${cookie.load("accessToken")}`,
                    },
                  }
                ).then((res) => {
                  return res.data;
                }).catch((e) => {
                  console.log(e)
                  return e?.response?.data ?? {success:false, message: e.message};
                }); */
        } catch (err) {
          console.log(err);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    /* 
    if(attachType==) */
  }

  render() {
    const postdata = this.state.postdata;
    const empPhoto = postdata?.empPhoto ?? "";
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="employee" {...this.props} />

            <div className="employee-view-scope">
            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName} Profile</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/hrms/employee"}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <div className="bg-gray-100 min-h-screen">
                            <div className="p-4">
                              <div className="rounded-md overflow-hidden shadow-sm">
                                <div className="p-4 bg-white rounded-md shadow-sm">
                                  <div className="flex flex-col md:flex-row gap-6">
                                    <div className="flex items-center">
                                      <div className="w-24 h-24 bg-gray-200 rounded-md flex items-center justify-center overflow-hidden">
                                        <span className="text-4xl font-bold text-gray-500">
                                          {empPhoto !== null &&
                                          empPhoto !== "" ? (
                                            <img
                                              src={`${downloadUrl}employeedoc/photos/${postdata?.empPhoto}`}
                                            />
                                          ) : (
                                            "Photo"
                                          )}
                                        </span>
                                      </div>
                                      <div className="ml-3">
                                        <div
                                          data-component-content="%7B%22className%22%3A%22flex%20items-center%20mb-1%22%7D"
                                          className="flex items-center mb-1"
                                        >
                                          <span className="w-2 h-2 rounded-full bg-green-500 mr-2"></span>
                                          <span className="text-sm text-gray-600">
                                            {postdata?.empStatus === "A"
                                              ? "Active"
                                              : "Inactive"}
                                          </span>
                                        </div>
                                        <div className="text-sm text-gray-600 mb-1">
                                          Employee ID: {postdata?.empCode ?? ""}
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                      <div className="flex flex-col md:flex-row md:flex-1 gap-4">
                                        <div className="flex items-center">
                                          <div className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-2">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="text-gray-600"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"></path>
                                            </svg>
                                          </div>
                                          <div className="text-sm text-gray-600">
                                            {postdata?.designationName ?? ""}
                                          </div>
                                        </div>
                                        <div className="flex items-center">
                                          <div className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-2">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="text-gray-600"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v1h10V9a2 2 0 0 0-2-2z"></path>
                                            </svg>
                                          </div>
                                          <div className="text-sm text-gray-600">
                                            {postdata?.departmentName ?? ""}
                                          </div>
                                        </div>
                                        <div className="flex items-center">
                                          <div className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center mr-2">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="text-gray-600"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"></path>
                                              <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                                            </svg>
                                          </div>
                                          <div className="text-sm text-gray-600">
                                            {postdata?.empCity ?? ""}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Date Of Birth
                                          </div>
                                          <div className="text-sm font-medium">
                                            {showDate(postdata?.empDOB ?? "")}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Date Of Joining
                                          </div>
                                          <div className="text-sm font-medium">
                                            {showDate(postdata?.empDOJ ?? "")}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Leaving Date
                                          </div>
                                          <div className="text-sm font-medium">
                                            {showDate(
                                              postdata?.empDateOfLeaving ?? "-"
                                            )}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Confirmation Date
                                          </div>
                                          <div className="text-sm font-medium">
                                            {showDate(
                                              postdata?.empConfirmationDate ??
                                                "-"
                                            )}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Company Email
                                          </div>
                                          <div className="text-sm font-medium">
                                            {postdata?.empEmail ?? "-"}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Mobile Number
                                          </div>
                                          <div className="text-sm font-medium">
                                            {postdata?.empMobile ?? "-"}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Reporting Manager
                                          </div>
                                          <div className="text-sm font-medium">
                                            {postdata?.empReporting ?? "-"}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-xs text-gray-500">
                                            Approving Manager
                                          </div>
                                          <div className="text-sm font-medium">
                                            {postdata?.empApproved ?? "-"}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-6 flex  emptablelist">
                                <div className="md:w-64 flex-shrink-0">
                                  <div className="bg-blue-600 text-white w-full md:w-64 md:min-h-[600px]">
                                    <ul className="space-y-2">
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "about"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "about"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>About</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "joining"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "joining"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Joining Details</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "pastcompany"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab ===
                                            "pastcompany"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Past Company Detail</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "organization"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab ===
                                            "organization"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Organization Info.</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "employeedocument"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab ===
                                            "employeedocument"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Document</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "salary"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "salary"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Salary Info.</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "personal"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "personal"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Personal Details</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "generateletters"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "family"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Generate Letters</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "family"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "family"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Family Details</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "miscellaneous"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab ===
                                            "miscellaneous"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Miscellaneous Info.</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "skillset"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "skillset"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Skill Set Details</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "language"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "language"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Language Details</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "separation"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab ===
                                            "separation"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Separation</span>
                                        </button>
                                      </li>
                                      <li
                                        onClick={this.selectTab.bind(
                                          this,
                                          "assets"
                                        )}
                                      >
                                        <button
                                          className={`flex items-center w-full px-3 py-2 rounded-md text-left text-sm ${
                                            this.state.activeTab === "assets"
                                              ? "bg-blue-700"
                                              : "hover:bg-blue-500"
                                          }`}
                                        >
                                          <span>Assets</span>
                                          <div className="ml-auto bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                                            1
                                          </div>
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="tablediv">
                                  {this.state.activeTab === "about" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          About
                                        </h2>
                                        <Link
                                          to={`/hrms/employee/edit/${this.state.editID}`}
                                        >
                                          <button className="text-gray-500 hover:text-gray-700">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="18"
                                              height="18"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="lucide lucide-edit"
                                            >
                                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                              <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                            </svg>
                                          </button>
                                        </Link>
                                      </div>
                                      <div className="p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Emp Code
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empCode ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Title
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empTitle ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              First Name
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empFirstName ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Last Name
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empLastName ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Gender
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empGender ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Blood Group
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empBloodGroup ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Date Of Birth
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(postdata?.empDOB) ??
                                                "-"}
                                            </div>
                                          </div>
                                        </div>
                                        <br />
                                        <br />
                                        <div>
                                          <h3 className="text-md font-semibold text-gray-700 mb-4">
                                            Reporting and Approving Manager
                                          </h3>
                                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div>
                                              <div className="text-xs text-gray-500 mb-1">
                                                Reporting Manager
                                              </div>
                                              <div className="text-sm font-medium">
                                                {postdata?.empReporting ?? "-"}
                                              </div>
                                            </div>
                                            <div>
                                              <div className="text-xs text-gray-500 mb-1">
                                                Approving Manager
                                              </div>
                                              <div className="text-sm font-medium">
                                                {postdata?.empApproved ?? "-"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "joining" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Joining Details
                                        </h2>
                                        <button className="text-gray-500 hover:text-gray-700">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-edit"
                                          >
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Status
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empStatus === "A"
                                                ? "Active"
                                                : "Inactive"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Contract Type
                                            </div>
                                            <div className="text-sm font-medium">
                                              {(() => {
                                                if (
                                                  postdata?.empContractType ===
                                                  1
                                                ) {
                                                  return "Consultant";
                                                } else if (
                                                  postdata?.empContractType ===
                                                  2
                                                ) {
                                                  return "Contract";
                                                } else if (
                                                  postdata?.empContractType ===
                                                  3
                                                ) {
                                                  return "Trainee";
                                                } else if (
                                                  postdata?.empContractType ===
                                                  4
                                                ) {
                                                  return "Probation";
                                                } else if (
                                                  postdata?.empContractType ===
                                                  5
                                                ) {
                                                  return "Permanent";
                                                }
                                              })()}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Company Email Id
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.empEmail ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Date Of Joining
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(
                                                postdata?.empDOJ ?? "-"
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Confirmation Date
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(
                                                postdata?.empConfirmationDate ??
                                                  "-"
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Date Of Leaving
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(
                                                postdata?.empDateOfLeaving ??
                                                  "-"
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Last Working Date
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(
                                                postdata?.empLastWorkingDate ??
                                                  "-"
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Pay Structure Applied From Date
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(
                                                postdata?.empPayStructureAppliedFromDate ??
                                                  "-"
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "pastcompany" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Past Employment Details
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showPastCompany",
                                            true
                                          )}
                                        >
                                          + Add New
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        {this.state.pastCompanyloading ? (
                                          showContaimerLoader()
                                        ) : (
                                          <div>
                                            {showPageView(
                                              this.state.pastCompanycurrentPage,
                                              this.state
                                                .pastCompanytotalRecords,
                                              "Past Employment"
                                            )}
                                            <div className="table-responsive">
                                              <table className="table text-nowrap text-md-nowrap mb-0">
                                                <thead>
                                                  <tr>
                                                    <th className="text-center">
                                                      Actions
                                                    </th>
                                                    <th>Company Name</th>
                                                    <th>Leaving Date</th>
                                                    <th>
                                                      Type of Industry /
                                                      Business
                                                    </th>
                                                    <th>Joining Date</th>
                                                    <th>
                                                      Reporting To Designation
                                                    </th>
                                                    <th>Department</th>
                                                    <th>
                                                      Designation on Joining
                                                    </th>
                                                    <th>
                                                      Designation on Leaving
                                                    </th>
                                                    <th>Leaving Reason</th>
                                                    <th>
                                                      Job Description
                                                      /Responsibilities
                                                    </th>
                                                    <th>Company address</th>
                                                    <th>Achievements</th>
                                                    <th>Financial Year</th>
                                                    <th>Last Salary Drawn</th>
                                                    <th>PF Office Name</th>
                                                    <th>PF Number</th>
                                                    <th>
                                                      PF Amount Transfered
                                                    </th>
                                                    <th>
                                                      Income After Exemption
                                                    </th>
                                                    <th>
                                                      US80C Benefit Claimed
                                                    </th>
                                                    <th>
                                                      Standard Deduction Benefit
                                                      Claimed
                                                    </th>
                                                    <th>Professional Tax</th>
                                                    <th>TDS / Tax Paid</th>
                                                    <th>Raw Tax</th>
                                                    <th>Surcharge</th>
                                                    <th>Cess</th>
                                                    <th>Attachment</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {this.state.pastEmploymentList
                                                    .length > 0 ? (
                                                    this.state.pastEmploymentList.map(
                                                      (item, index) => {
                                                        return (
                                                          <tr key={index}>
                                                            <td className="text-center text-nowrap align-middle">
                                                              <a
                                                                href={void 0}
                                                                onClick={this.editPasEmployment.bind(
                                                                  this,
                                                                  item
                                                                )}
                                                                className="me-2"
                                                              >
                                                                <i className="fa fa-pencil-square-o"></i>
                                                              </a>
                                                              <a
                                                                href={void 0}
                                                                className="delete_record"
                                                                data="Delete"
                                                                onClick={this.removeItem.bind(
                                                                  this,
                                                                  encodeValue(
                                                                    item.prevCompID
                                                                  ),
                                                                  "prevcompany",
                                                                  this.state
                                                                    .pastCompanycurrentPage,
                                                                  "pastcompany"
                                                                )}
                                                              >
                                                                <i className="fa fa-trash"></i>
                                                              </a>
                                                            </td>
                                                            <td>
                                                              {item.companyName}
                                                            </td>
                                                            <td>
                                                              {showDate(
                                                                item.leavingDate
                                                              )}
                                                            </td>
                                                            <td>
                                                              {
                                                                item.industryName
                                                              }
                                                            </td>
                                                            <td>
                                                              {showDate(
                                                                item.JoiningDate
                                                              )}
                                                            </td>
                                                            <td>
                                                              {
                                                                item.reportingToDesignation
                                                              }
                                                            </td>
                                                            <td>
                                                              {item.department}
                                                            </td>
                                                            <td>
                                                              {
                                                                item.designationJoining
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.designationLeaving
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.leavingReason
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.responsibilities
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.companyAddress
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.achievements
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.financialYear
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.lastSalaryDrawn
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.PFOfficeName
                                                              }
                                                            </td>
                                                            <td>
                                                              {item.PFNumber}
                                                            </td>
                                                            <td>
                                                              {
                                                                item.PFAmountTransfered
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.incomeAfterExemption
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.US80CBenefitClaimed
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.standardDeductionBenefitClaimed
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                item.professionalTax
                                                              }
                                                            </td>
                                                            <td>
                                                              {item.TDSTaxPaid}
                                                            </td>
                                                            <td>
                                                              {item.rawTax}
                                                            </td>
                                                            <td>
                                                              {item.surcharge}
                                                            </td>
                                                            <td>{item.cess}</td>
                                                            <td>
                                                              {item.attachment}
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        className="text-center"
                                                        colSpan={8}
                                                      >
                                                        No Past Employment
                                                        Details Found
                                                      </td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                            <Pagenation
                                              params={{
                                                totalRecords:
                                                  this.state
                                                    .pastCompanytotalRecords,
                                                totalPage:
                                                  this.state
                                                    .pastCompanytotalPage,
                                                currentPage:
                                                  this.state
                                                    .pastCompanycurrentPage,
                                              }}
                                              addParam={"pastcompany"}
                                              sateValChange={this.sateValChange}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "organization" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Organization Information
                                        </h2>
                                      </div>
                                      <div className="p-4">
                                        <div className="table-responsive">
                                          <table className="table text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  Structure Name / Category Type
                                                </th>
                                                <th>
                                                  List of value / Selection
                                                </th>
                                                <th>Effective Date</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>Company Name</td>
                                                <td>
                                                  {postdata?.companyName ?? "-"}
                                                </td>
                                                <td>
                                                  {postdata?.empDOJ ?? "-"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>PT Applicable</td>
                                                <td>
                                                  {postdata?.empPTApplicable ===
                                                  "Yes"
                                                    ? "Applicable"
                                                    : "Not Applicable"}
                                                </td>
                                                <td>
                                                  {showDate(
                                                    postdata?.empPTDate ?? ""
                                                  )}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Staff Category</td>
                                                <td>
                                                  {postdata?.staffcategoryName ??
                                                    "-"}
                                                </td>
                                                <td>
                                                  {postdata?.empDOJ ?? "-"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Branch</td>
                                                <td>
                                                  {postdata?.branchName ?? "-"}
                                                </td>
                                                <td>
                                                  {postdata?.empDOJ ?? "-"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Department</td>
                                                <td>
                                                  {postdata?.departmentName ??
                                                    "-"}
                                                </td>
                                                <td>
                                                  {postdata?.empDOJ ?? "-"}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Designation</td>
                                                <td>
                                                  {postdata?.designationName ??
                                                    "-"}
                                                </td>
                                                <td>
                                                  {postdata?.empDOJ ?? "-"}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab ===
                                    "employeedocument" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Past Employment Details
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showdocumentPopup",
                                            true
                                          )}
                                        >
                                          + Add New
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        {this.state.documentloading ? (
                                          showContaimerLoader()
                                        ) : (
                                          <div>
                                            {showPageView(
                                              this.state.documentcurrentPage,
                                              this.state.documenttotalRecords,
                                              "Past Employment"
                                            )}
                                            <div className="table-responsive">
                                              <table className="table text-nowrap text-md-nowrap mb-0">
                                                <thead>
                                                  <tr>
                                                    <th className="text-center">
                                                      Actions
                                                    </th>
                                                    <th>Document Name</th>
                                                    <th>Number</th>
                                                    <th>Name in Document</th>
                                                    <th>Issue Date</th>
                                                    <th>Issue Place</th>
                                                    <th>Expiry Date</th>
                                                    <th>Files</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {this.state.documentList
                                                    .length > 0 ? (
                                                    this.state.documentList.map(
                                                      (item, index) => {
                                                        return (
                                                          <tr key={index}>
                                                            <td className="text-center text-nowrap align-middle">
                                                              <a
                                                                href={void 0}
                                                                onClick={this.editdocument.bind(
                                                                  this,
                                                                  item
                                                                )}
                                                                className="me-2"
                                                              >
                                                                <i className="fa fa-pencil-square-o"></i>
                                                              </a>
                                                              <a
                                                                href={void 0}
                                                                className="delete_record"
                                                                data="Delete"
                                                                onClick={this.removeItem.bind(
                                                                  this,
                                                                  encodeValue(
                                                                    item.docID
                                                                  ),
                                                                  "document",
                                                                  this.state
                                                                    .documentcurrentPage,
                                                                  "document"
                                                                )}
                                                              >
                                                                <i className="fa fa-trash"></i>
                                                              </a>
                                                            </td>
                                                            <td>
                                                              {
                                                                item.empdoctypeName
                                                              }
                                                            </td>
                                                            <td>
                                                              {item.docNumber}
                                                            </td>
                                                            <td>
                                                              {item.docName}
                                                            </td>
                                                            <td>
                                                              {
                                                                item.docIssuePlace
                                                              }
                                                            </td>
                                                            <td>
                                                              {showDate(
                                                                item.docIssueDate
                                                              )}
                                                            </td>
                                                            <td>
                                                              {showDate(
                                                                item.docExpiryDate
                                                              )}
                                                            </td>
                                                            <td>
                                                              {item.docFile}
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        className="text-center"
                                                        colSpan={8}
                                                      >
                                                        No Document Found
                                                      </td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                            <Pagenation
                                              params={{
                                                totalRecords:
                                                  this.state
                                                    .documenttotalRecords,
                                                totalPage:
                                                  this.state.documenttotalPage,
                                                currentPage:
                                                  this.state
                                                    .documentcurrentPage,
                                              }}
                                              addParam={"document"}
                                              sateValChange={this.sateValChange}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "salary" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Salary Information
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showSalaryPopup",
                                            true
                                          )}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-edit"
                                          >
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="p-4">
                                       dsadadad
                                      </div>
                                    </div>
                                  )}

                                  {this.state.activeTab === "personal" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Personal Information
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showpersonalInformationPopup",
                                            true
                                          )}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-edit"
                                          >
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Father Name
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.fatherName ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Mother Name
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.MotherName ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Marital Status
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.maritalStatus ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Marriage Date
                                            </div>
                                            <div className="text-sm font-medium">
                                              {showDate(
                                                postdata?.marriageDate ?? ""
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Personal Email Id
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.personalEmailId ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Nominee Email
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.nomineeEmail ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Religion
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.religion ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Nationality
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.nationality ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Country Of Birth
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.countryOfBirth ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              State Of Birth
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.stateOfBirth ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Place Of Birth
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.placeOfBirth ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Physical Disabilities
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.physicalDisabilities ??
                                                "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Disability Remark
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.disabilityRemark ??
                                                "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Identification Mark 1
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.identificationMark1 ??
                                                "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Identification Mark 2
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.identificationMark2 ??
                                                "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Extra Curricular Interest /
                                              Hobbies
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.extraCurricularInterest ??
                                                "-"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab ===
                                    "generateletters" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Generate Letters
                                        </h2>
                                      </div>
                                      <div className="p-4">
                                        <div className="table-responsive">
                                          <table className="table text-nowrap text-md-nowrap mb-0">
                                            <tbody>
                                              <tr>
                                                <td>Appointment Letter</td>
                                                <td>
                                                  <button
                                                    className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                                    onClick={this.generateLetter.bind(
                                                      this,
                                                      "AppointmentLetter"
                                                    )}
                                                    id="AppointmentLetter"
                                                  >
                                                    Generate
                                                  </button>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Confidentiality</td>
                                                <td>
                                                  <button
                                                    className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                                    onClick={this.generateLetter.bind(
                                                      this,
                                                      "Confidentiality"
                                                    )}
                                                    id="Confidentiality"
                                                  >
                                                    Generate
                                                  </button>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Confirmation Letter</td>
                                                <td>
                                                  <button
                                                    className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                                    onClick={this.generateLetter.bind(
                                                      this,
                                                      "ConfirmationLetter"
                                                    )}
                                                    id="ConfirmationLetter"
                                                  >
                                                    Generate
                                                  </button>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>Offer Letter</td>
                                                <td>
                                                  <button
                                                    className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                                    onClick={this.generateLetter.bind(
                                                      this,
                                                      "OfferLetter"
                                                    )}
                                                    id="OfferLetter"
                                                  >
                                                    Generate
                                                  </button>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "family" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Family Details
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showFamilyPopup",
                                            true
                                          )}
                                        >
                                          + Add New
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        {showPageView(
                                          this.state.familycurrentPage,
                                          this.state.familytotalRecords,
                                          "Family"
                                        )}
                                        <div className="table-responsive">
                                          <table className="table text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                              <tr>
                                                <th className="text-center">
                                                  Actions
                                                </th>
                                                <th>Title</th>
                                                <th>Name</th>
                                                <th>Is Dependent</th>
                                                <th>Gender</th>
                                                <th>Relation</th>
                                                <th>Address</th>
                                                <th>Blood Group</th>
                                                <th>Contact No</th>
                                                <th>Date of Birth</th>
                                                <th>Marital Status</th>
                                                <th>Marriage Date</th>
                                                <th>Employment</th>
                                                <th>Profession</th>
                                                <th>Nationality</th>
                                                <th>Insurance Number</th>
                                                <th>Remarks</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.familyList.length >
                                              0 ? (
                                                this.state.familyList.map(
                                                  (item, index) => {
                                                    return (
                                                      <tr key={index}>
                                                        <td className="text-center text-nowrap align-middle">
                                                          <a
                                                            href={void 0}
                                                            onClick={this.editFamilyInfo.bind(
                                                              this,
                                                              item
                                                            )}
                                                            className="me-2"
                                                          >
                                                            <i className="fa fa-pencil-square-o"></i>
                                                          </a>
                                                          <a
                                                            href={void 0}
                                                            className="delete_record"
                                                            data="Delete"
                                                            onClick={this.removeItem.bind(
                                                              this,
                                                              encodeValue(
                                                                item.familyID
                                                              ),
                                                              "family",
                                                              this.state
                                                                .pastCompanycurrentPage,
                                                              "family"
                                                            )}
                                                          >
                                                            <i className="fa fa-trash"></i>
                                                          </a>
                                                        </td>
                                                        <td>
                                                          {item.familyTitle}
                                                        </td>
                                                        <td>
                                                          {item.familyName}
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyIsDependent
                                                          }
                                                        </td>
                                                        <td>
                                                          {item.familyGender}
                                                        </td>
                                                        <td>
                                                          {item.familyRelation}
                                                        </td>
                                                        <td>
                                                          {item.familyAddress}
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyBloodGroup
                                                          }
                                                        </td>
                                                        <td>
                                                          {item.familyContactNo}
                                                        </td>
                                                        <td>
                                                          {item.familyDOB}
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyMaritalStatus
                                                          }
                                                        </td>
                                                        <td>
                                                          {showDate(
                                                            item.familyMarriageDate
                                                          )}
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyEmployment
                                                          }
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyProfession
                                                          }
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyNationality
                                                          }
                                                        </td>
                                                        <td>
                                                          {
                                                            item.familyInsuranceNumber
                                                          }
                                                        </td>
                                                        <td>
                                                          {item.familyRemarks}
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    className="text-center"
                                                    colSpan={8}
                                                  >
                                                    No Family Details Found
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                          <Pagenation
                                            params={{
                                              totalRecords:
                                                this.state.familytotalRecords,
                                              totalPage:
                                                this.state.familytotalPage,
                                              currentPage:
                                                this.state.familycurrentPage,
                                            }}
                                            addParam={"family"}
                                            sateValChange={this.sateValChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "miscellaneous" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Miscellaneous Information
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showMiscellaneousPopup",
                                            true
                                          )}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-edit"
                                          >
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Height (In CMs)
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.miscellaneous
                                                ?.Height ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Weight (In KGs)
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.miscellaneous
                                                ?.Weight ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              BMI
                                            </div>
                                            <div className="text-sm font-medium">
                                              {"-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Blood Group
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.miscellaneous
                                                ?.BloodGroup ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Shoe Size
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.miscellaneous
                                                ?.ShoeSize ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              Shirt Size
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.miscellaneous
                                                ?.ShirtSize ?? "-"}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-xs text-gray-500 mb-1">
                                              T-Shirt Size
                                            </div>
                                            <div className="text-sm font-medium">
                                              {postdata?.miscellaneous
                                                ?.TShirtSize ?? "-"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "skillset" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Skill Set Details
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showSkillSetPopup",
                                            true
                                          )}
                                        >
                                          + Add New
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        <div className="table-responsive">
                                          <table className="table text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                              <tr>
                                                <th>Skill Name</th>
                                                <th>Skill Type</th>
                                                <th>Skill Level</th>
                                                <th>Effective Date</th>
                                                <th className="text-center">
                                                  Actions{" "}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.skillSetList.length >
                                              0 ? (
                                                this.state.skillSetList.map(
                                                  (item, index) => {
                                                    return (
                                                      <tr key={index}>
                                                        <td>
                                                          {item.empskillName}
                                                        </td>
                                                        <td>
                                                          {item.empskillsetType}
                                                        </td>
                                                        <td>
                                                          {
                                                            item.empskillsetLevel
                                                          }
                                                        </td>
                                                        <td>
                                                          {item.empskillsetWEF}
                                                        </td>
                                                        <td className="text-center text-nowrap align-middle">
                                                          <a
                                                            href={void 0}
                                                            onClick={this.editSkillSet.bind(
                                                              this,
                                                              item
                                                            )}
                                                            className="me-2"
                                                          >
                                                            <i className="fa fa-pencil-square-o"></i>
                                                          </a>
                                                          <a
                                                            href={void 0}
                                                            className="delete_record"
                                                            data="Delete"
                                                            onClick={this.removeItem.bind(
                                                              this,
                                                              encodeValue(
                                                                item.empskillsetID
                                                              ),
                                                              "skillSet",
                                                              this.state
                                                                .skillSetcurrentPage,
                                                              "skillSet"
                                                            )}
                                                          >
                                                            <i className="fa fa-trash"></i>
                                                          </a>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    className="text-center"
                                                    colSpan={8}
                                                  >
                                                    No Skill Set Found
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>

                                          <Pagenation
                                            params={{
                                              totalRecords:
                                                this.state.skillSettotalRecords,
                                              totalPage:
                                                this.state.skillSettotalPage,
                                              currentPage:
                                                this.state.skillSetcurrentPage,
                                            }}
                                            addParam={"skillset"}
                                            sateValChange={this.sateValChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {this.state.activeTab === "language" && (
                                    <div className="bg-white rounded-md shadow-sm">
                                      <div className="flex justify-between items-center p-4 border-b">
                                        <h2 className="text-lg font-semibold text-gray-800">
                                          Language Details
                                        </h2>
                                        <button
                                          className="text-gray-500 hover:text-gray-700 btn btn-primary"
                                          onClick={this.openPopup.bind(
                                            this,
                                            "showLanguagePopup",
                                            true
                                          )}
                                        >
                                          + Add New
                                        </button>
                                      </div>
                                      <div className="p-4">
                                        <div className="table-responsive">
                                          <table className="table text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                              <tr>
                                                <th>Language Name</th>
                                                <th>Mother Tongue</th>
                                                <th>Speak</th>
                                                <th>Read</th>
                                                <th>Write</th>
                                                <th className="text-center">
                                                  Actions
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {this.state.employeelanguageList
                                                .length > 0 ? (
                                                this.state.employeelanguageList.map(
                                                  (item, index) => {
                                                    return (
                                                      <tr key={index}>
                                                        <td>
                                                          {item.languageName}
                                                        </td>
                                                        <td>
                                                          {item.emplanguageMotherTongue ===
                                                          "Y"
                                                            ? "Yes"
                                                            : "No"}
                                                        </td>
                                                        <td>
                                                          {item.emplanguageSpeak ===
                                                          "Y"
                                                            ? "Yes"
                                                            : "No"}
                                                        </td>
                                                        <td>
                                                          {item.emplanguageRead ===
                                                          "Y"
                                                            ? "Yes"
                                                            : "No"}
                                                        </td>
                                                        <td>
                                                          {item.emplanguageWrite ===
                                                          "Y"
                                                            ? "Yes"
                                                            : "No"}
                                                        </td>
                                                        <td className="text-center text-nowrap align-middle">
                                                          <a
                                                            href={void 0}
                                                            onClick={this.editemployeelanguage.bind(
                                                              this,
                                                              item
                                                            )}
                                                            className="me-2"
                                                          >
                                                            <i className="fa fa-pencil-square-o"></i>
                                                          </a>
                                                          <a
                                                            href={void 0}
                                                            className="delete_record"
                                                            data="Delete"
                                                            onClick={this.removeItem.bind(
                                                              this,
                                                              encodeValue(
                                                                item.emplanguageID
                                                              ),
                                                              "employeelanguage",
                                                              this.state
                                                                .employeelanguagecurrentPage,
                                                              "employeelanguage"
                                                            )}
                                                          >
                                                            <i className="fa fa-trash"></i>
                                                          </a>
                                                        </td>
                                                      </tr>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    className="text-center"
                                                    colSpan={8}
                                                  >
                                                    No Language Found
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>

                                          <Pagenation
                                            params={{
                                              totalRecords:
                                                this.state.totalRecords,
                                              totalPage: this.state.totalPage,
                                              currentPage:
                                                this.state.currentPage,
                                            }}
                                            addParam={"pastcompany"}
                                            sateValChange={this.sateValChange}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.showPastCompany}
          onHide={() => this.openPopup("showPastCompany", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Past Company Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">
                  Company Name<span className="lbl-error">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Company Name"
                  name="companyName"
                  onChange={this.handleChangeText}
                  value={this.state.companyName}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">
                  Leaving Date<span className="lbl-error">*</span>
                </label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                  selected={this.state.leavingDate}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={this.handleChangeDate.bind(this, "leavingDate")}
                />
              </div>
            </div>
            <div className="panel panel-primary">
              <div className=" tab-menu-heading">
                <div className="tabs-menu1">
                  <ul className="nav panel-tabs">
                    <li>
                      <a href="#tab1" className="active" data-bs-toggle="tab">
                        Company Details
                      </a>
                    </li>
                    <li>
                      <a href="#tab2" data-bs-toggle="tab">
                        Salary & Income Tax Details
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="panel-body tabs-menu-body">
                <div className="tab-content">
                  <div className="tab-pane active" id="tab1">
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Type of Industry / Business
                        </label>
                        <Select
                          value={this.state.typeOfBusiness}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "typeOfBusiness"
                          )}
                          placeholder="Select Title"
                          isClearable={true}
                          options={this.state.industryList}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Joining Date</label>
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="form-control"
                          selected={this.state.JoiningDate}
                          maxDate={new Date()}
                          dateFormat="dd/MM/yyyy"
                          onChange={this.handleChangeDate.bind(
                            this,
                            "JoiningDate"
                          )}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Reporting To Designation
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Reporting To Designation"
                          name="reportingToDesignation"
                          onChange={this.handleChangeText}
                          value={this.state.reportingToDesignation}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Department</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Department"
                          name="department"
                          onChange={this.handleChangeText}
                          value={this.state.department}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Designation on Joining
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Designation on Joining"
                          name="designationJoining"
                          onChange={this.handleChangeText}
                          value={this.state.designationJoining}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Designation on Leaving
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Designation on Leaving"
                          name="designationLeaving"
                          onChange={this.handleChangeText}
                          value={this.state.designationLeaving}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Leaving Reason</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Leaving Reason"
                          name="leavingReason"
                          onChange={this.handleChangeText}
                          value={this.state.leavingReason}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Job Description / Responsibilities
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Job Description / Responsibilities"
                          name="responsibilities"
                          onChange={this.handleChangeText}
                          value={this.state.responsibilities}
                        ></textarea>
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Company address</label>
                        <textarea
                          className="form-control"
                          placeholder="Company address"
                          name="companyAddress"
                          onChange={this.handleChangeText}
                          value={this.state.companyAddress}
                        ></textarea>
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Achievements</label>
                        <textarea
                          className="form-control"
                          placeholder="Achievements"
                          name="achievements"
                          onChange={this.handleChangeText}
                          value={this.state.achievements}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tab2">
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label className="form-label">Financial Year</label>
                        <Select
                          value={this.state.financialYear}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "financialYear"
                          )}
                          placeholder="Select Financial Year"
                          isClearable={true}
                          options={financialYearList}
                        />
                      </div>
                    </div>

                    <h3 className="page-title">Salary Details</h3>
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label className="form-label">Last Salary Drawn</label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Last Salary Drawn"
                          name="lastSalaryDrawn"
                          onChange={this.handleChangeText}
                          value={this.state.lastSalaryDrawn}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">PF Office Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="PF Office Name"
                          name="PFOfficeName"
                          onChange={this.handleChangeText}
                          value={this.state.PFOfficeName}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">PF Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="PF Number"
                          name="PFNumber"
                          onChange={this.handleChangeText}
                          value={this.state.PFNumber}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          PF Amount Transfered
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="PF Amount Transfered"
                          name="PFAmountTransfered"
                          onChange={this.handleChangeText}
                          value={this.state.PFAmountTransfered}
                        />
                      </div>
                    </div>
                    <h3 className="page-title">Income Tax Details</h3>
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Income After Exemption
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Income After Exemption"
                          name="incomeAfterExemption"
                          onChange={this.handleChangeText}
                          value={this.state.incomeAfterExemption}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          US80C Benefit Claimed
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="US80C Benefit Claimed"
                          name="US80CBenefitClaimed"
                          onChange={this.handleChangeText}
                          value={this.state.US80CBenefitClaimed}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">
                          Standard Deduction Benefit Claimed
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Standard Deduction Benefit Claimed"
                          name="standardDeductionBenefitClaimed"
                          onChange={this.handleChangeText}
                          value={this.state.standardDeductionBenefitClaimed}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Professional Tax</label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Professional Tax"
                          name="professionalTax"
                          onChange={this.handleChangeText}
                          value={this.state.professionalTax}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">TDS / Tax Paid</label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="TDS / Tax Paid"
                          name="TDSTaxPaid"
                          onChange={this.handleChangeText}
                          value={this.state.TDSTaxPaid}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Raw Tax</label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Raw Tax"
                          name="rawTax"
                          onChange={this.handleChangeText}
                          value={this.state.rawTax}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Surcharge</label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Surcharge"
                          name="surcharge"
                          onChange={this.handleChangeText}
                          value={this.state.surcharge}
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label className="form-label">Cess</label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          min={1}
                          className="form-control"
                          placeholder="Cess"
                          name="cess"
                          onChange={this.handleChangeText}
                          value={this.state.cess}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="form-group">
                  <label className="form-label mt-0">Attachment</label>
                  {this.state.prevcompanyattachment !== "" &&
                  this.state.prevcompanyattachment !== null ? (
                    <>
                      <a
                        href={`${downloadUrl}employeedoc/prevcompany/${this.state.prevcompanyattachment}`}
                        target="blank"
                      >
                        <i className="fa fa-download"></i>
                      </a>{" "}
                      <span>{this.state.prevcompanyattachment}</span>{" "}
                      <i
                        className="fa fa-trash"
                        onClick={this.removeAttach.bind(this, "prevcompany")}
                      ></i>
                      <br />
                    </>
                  ) : (
                    <input
                      className="form-control"
                      type="file"
                      id="prevcompanyattachment"
                    />
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showPastCompany", false)}
            >
              Close
            </Button>
            <Button variant="primary" onClick={this.savePastCompany.bind(this)}>
              {this.state.prevCompID !== "" ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showFamilyPopup}
          onHide={() => this.openPopup("showFamilyPopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Family Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-2">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="familyIsDependent"
                    value="Yes"
                    onChange={this.handleChangeCheckbox}
                  />
                  <span className="custom-control-label">Is Dependent</span>
                </label>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">Title</label>
                <Select
                  value={this.state.familyTitle}
                  onChange={this.handleSelectChange.bind(this, "familyTitle")}
                  placeholder="Select Title"
                  isClearable={true}
                  options={titleList}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  name="familyName"
                  onChange={this.handleChangeText}
                  value={this.state.familyName}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Gender</label>
                <Select
                  value={this.state.familyGender}
                  onChange={this.handleSelectChange.bind(this, "familyGender")}
                  placeholder="Select Gender"
                  isClearable={true}
                  options={genderList}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Relation</label>
                <Select
                  value={this.state.familyRelation}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "familyRelation"
                  )}
                  placeholder="Select Relation"
                  isClearable={true}
                  options={maleRelation}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  name="familyAddress"
                  onChange={this.handleChangeText}
                  value={this.state.familyAddress}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Blood Group</label>
                <Select
                  value={this.state.familyBloodGroup}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "familyBloodGroup"
                  )}
                  placeholder="Select Relation"
                  isClearable={true}
                  options={bloodGroup}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Contact No</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  name="familyContactNo"
                  onChange={this.handleChangeText}
                  value={this.state.familyContactNo}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Date of Birth</label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                  selected={this.state.familyDOB}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={this.handleChangeDate.bind(this, "familyDOB")}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Marital Status</label>
                <Select
                  value={this.state.familyMaritalStatus}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "familyMaritalStatus"
                  )}
                  placeholder="Select Title"
                  isClearable={true}
                  options={maritalStatus}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Marriage Date</label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                  selected={this.state.familyMarriageDate}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={this.handleChangeDate.bind(
                    this,
                    "familyMarriageDate"
                  )}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Employment</label>
                <Select
                  value={this.state.familyEmployment}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "familyEmployment"
                  )}
                  placeholder="Select Title"
                  isClearable={true}
                  options={[
                    { value: "Employed", label: "Employed" },
                    { value: "UnEmployed", label: "UnEmployed" },
                  ]}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Profession</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Profession"
                  name="familyProfession"
                  onChange={this.handleChangeText}
                  value={this.state.familyProfession}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Nationality</label>
                <Select
                  value={this.state.familyNationality}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "familyNationality"
                  )}
                  placeholder="Select Nationality"
                  isClearable={true}
                  options={nationalityList}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Insurance Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Insurance Number"
                  name="familyInsuranceNumber"
                  onChange={this.handleChangeText}
                  value={this.state.familyInsuranceNumber}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Remarks"
                  name="familyRemarks"
                  onChange={this.handleChangeText}
                  value={this.state.familyRemarks}
                />
              </div>
              <div className="form-group col-md-4">
                <div className="form-group">
                  <label className="form-label mt-0">Attachment</label>
                  <input className="form-control" type="file" />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showFamilyPopup", false)}
            >
              Close
            </Button>
            <Button variant="primary" onClick={this.saveFamilyInfo.bind(this)}>
              {this.state.familyID !== "" ? "Update" : "Save"}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showSkillSetPopup}
          onHide={() => this.openPopup("showSkillSetPopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Skill Set Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">Skill Name</label>
                <Select
                  value={this.state.empskillID ?? ""}
                  onChange={this.handleSelectChange.bind(this, "empskillID")}
                  placeholder="Select Skill"
                  isClearable={true}
                  options={this.state.skillList}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Skill Type</label>
                <Select
                  value={this.state.empskillsetType}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "empskillsetType"
                  )}
                  placeholder="Select Title"
                  isClearable={true}
                  options={[
                    { label: "PRIMARY", value: "PRIMARY" },
                    { label: "SECONDARY", value: "SECONDARY" },
                  ]}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Skill Level</label>
                <Select
                  value={this.state.empskillsetLevel}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "empskillsetLevel"
                  )}
                  placeholder="Select Title"
                  isClearable={true}
                  options={[
                    { label: "Level1", value: "1" },
                    { label: "Level2", value: "2" },
                    { label: "Level3", value: "3" },
                    { label: "Level4", value: "4" },
                    { label: "Level5", value: "5" },
                  ]}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">WEF</label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                  placeholderText="Select WEF"
                  selected={this.state.empskillsetWEF}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={this.handleChangeDate.bind(this, "empskillsetWEF")}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showSkillSetPopup", false)}
            >
              Close
            </Button>
            <Button variant="primary" onClick={this.saveSkill.bind(this)}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showLanguagePopup}
          onHide={() => this.openPopup("showLanguagePopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Language Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">Language Name</label>
                <Select
                  value={this.state.languageID}
                  onChange={this.handleSelectChange.bind(this, "languageID")}
                  placeholder="Select Title"
                  isClearable={true}
                  options={this.state.languageList}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-2">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="emplanguageMotherTongue"
                    value="Yes"
                    checked={this.state.emplanguageMotherTongue}
                    onChange={this.handleChangeCheckbox}
                  />
                  <span className="custom-control-label">Mother Tongue</span>
                </label>
              </div>
              <div className="form-group col-md-2">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="emplanguageSpeak"
                    value="Yes"
                    checked={this.state.emplanguageSpeak}
                    onChange={this.handleChangeCheckbox}
                  />
                  <span className="custom-control-label">Speak</span>
                </label>
              </div>
              <div className="form-group col-md-2">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="emplanguageRead"
                    value="Yes"
                    checked={this.state.emplanguageRead}
                    onChange={this.handleChangeCheckbox}
                  />
                  <span className="custom-control-label">Read</span>
                </label>
              </div>
              <div className="form-group col-md-2">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="emplanguageWrite"
                    value="Yes"
                    checked={this.state.emplanguageWrite}
                    onChange={this.handleChangeCheckbox}
                  />
                  <span className="custom-control-label">Write</span>
                </label>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showLanguagePopup", false)}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={this.saveLanguage.bind(this)}
              id="saveLanguage"
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showMiscellaneousPopup}
          onHide={() => this.openPopup("showMiscellaneousPopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Miscellaneous Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">Height (In CMs)</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  placeholder="Height (In CMs)"
                  name="Height"
                  onChange={this.handleChangeText}
                  value={this.state.Height}
                  min={1}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Weight (In KGs)</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  placeholder="Weight (In KGs)"
                  name="Weight"
                  onChange={this.handleChangeText}
                  value={this.state.Weight}
                  min={1}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Blood Group</label>
                <Select
                  value={this.state.BloodGroup}
                  onChange={this.handleSelectChange.bind(this, "BloodGroup")}
                  placeholder="Select Blood Group"
                  isClearable={true}
                  options={bloodGroup}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Shoe Size</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  placeholder="Shoe Size"
                  name="ShoeSize"
                  onChange={this.handleChangeText}
                  value={this.state.ShoeSize}
                  min={1}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Shirt Size</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  placeholder="Shirt Size"
                  name="ShirtSize"
                  onChange={this.handleChangeText}
                  value={this.state.ShirtSize}
                  min={1}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">T-Shirt Size</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  placeholder="T-Shirt Size"
                  name="TShirtSize"
                  onChange={this.handleChangeText}
                  value={this.state.TShirtSize}
                  min={1}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showMiscellaneousPopup", false)}
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={this.saveMiscellaneous.bind(this)}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showdocumentPopup}
          onHide={() => this.openPopup("showdocumentPopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Document Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">Document Type</label>
                <Select
                  value={this.state.docTypeID}
                  onChange={this.handleSelectChange.bind(this, "docTypeID")}
                  placeholder="Select Document Type"
                  isClearable={true}
                  options={this.state.docTypeList}
                  isDisabled={this.state.docID !== "" ? true : false}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Document Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Document Number"
                  name="docNumber"
                  onChange={this.handleChangeText}
                  value={this.state.docNumber}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Name in Document</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name in Document"
                  name="docName"
                  onChange={this.handleChangeText}
                  value={this.state.docName}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Document Issue Place</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Document Issue Place"
                  name="docIssuePlace"
                  onChange={this.handleChangeText}
                  value={this.state.docIssuePlace}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Issue Date</label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                  selected={this.state.docIssueDate}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={this.handleChangeDate.bind(this, "docIssueDate")}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Expiry Date</label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                  selected={this.state.docExpiryDate}
                  minDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  onChange={this.handleChangeDate.bind(this, "docExpiryDate")}
                />
              </div>
              <div className="form-group col-md-4">
                <div className="form-group">
                  <label className="form-label mt-0">Attachment</label>
                  <input className="form-control" type="file" />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showdocumentPopup", false)}
            >
              Close
            </Button>
            <Button
              variant="primary"
              id="savedocument"
              onClick={this.savedocument.bind(this)}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showSalaryPopup}
          onHide={() => this.openPopup("showSalaryPopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Salary Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group col-md-4">
              <label className="form-label">Affected From</label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={this.state.salaryAffectedDate}
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChangeDate.bind(this, "salaryAffectedDate")}
              />
            </div>
            <div className="table-responsive">
              <table className="table border text-nowrap text-md-nowrap mb-0">
                <thead className="table-primary">
                  <tr>
                    <th>WAGE TYPE DESCRIPTION</th>
                    <th width="200">PAY BASIS</th>
                    <th>AMOUNT</th>
                    <th>ANNUALLY</th>
                    <th>MANUALLY</th>
                    <th>REFERENCE/REMARKS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="table-info">
                    <td colSpan={6}>CTC Wise Input</td>
                  </tr>
                  <tr>
                    <td>CTC Total</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.ctctotal?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "ctctotal",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="ctctotal-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "ctctotal",
                          "amount"
                        )}
                        value={this.state.salaryDetails?.ctctotal?.amount ?? ""}
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="ctctotal-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "ctctotal",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.ctctotal?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Gratuity Amount Manual</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.gratuityamountmanual
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "gratuityamountmanual",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="gratuityamountmanual-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "gratuityamountmanual",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.gratuityamountmanual
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="gratuityamountmanual-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "gratuityamountmanual",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.gratuityamountmanual
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr className="table-info">
                    <td colSpan={6}>Salary Structure</td>
                  </tr>
                  <tr>
                    <td colSpan={6}>Regular Earning</td>
                  </tr>
                  <tr>
                    <td>Basic Salary</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.basicsalary?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "basicsalary",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="basicsalary-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "basicsalary",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.basicsalary?.amount ?? ""
                        }
                      />
                    </td>
                    <td>
                      ₹
                      {this.state.salaryDetails?.basicsalary?.amount * 12 ?? ""}
                    </td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="basicsalary-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "basicsalary",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.basicsalary?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Consultancy Fees</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.consultancyfees
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "consultancyfees",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="consultancyfees-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "consultancyfees",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.consultancyfees?.amount ??
                          ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="consultancyfees-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "consultancyfees",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.consultancyfees?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Contract Fee</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.contractfee?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "contractfee",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="contractfee-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "contractfee",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.contractfee?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="contractfee-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "contractfee",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.contractfee?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Conveyance Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.conveyanceallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "conveyanceallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="conveyanceallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "conveyanceallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.conveyanceallowance
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="conveyanceallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "conveyanceallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.conveyanceallowance
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>DA</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.da?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "da",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="da-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "da",
                          "amount"
                        )}
                        value={this.state.salaryDetails?.da?.amount ?? ""}
                      />
                    </td>
                    <td>₹{this.state.salaryDetails?.da?.amount * 12 ?? ""}</td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="da-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "da",
                          "remarks"
                        )}
                        value={this.state.salaryDetails?.da?.remarks ?? ""}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Education Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.educationallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "educationallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="educationallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "educationallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.educationallowance
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="educationallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "educationallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.educationallowance
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Food Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.foodallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "foodallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="foodallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "foodallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.foodallowance?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="foodallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "foodallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.foodallowance?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>House Rent Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.houserentallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "houserentallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="houserentallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "houserentallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.houserentallowance
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td>
                      ₹
                      {this.state.salaryDetails?.houserentallowance?.amount *
                        12 ?? ""}
                    </td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="houserentallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "houserentallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.houserentallowance
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Leave Travel Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.leavetravelallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "leavetravelallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="leavetravelallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "leavetravelallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.leavetravelallowance
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="leavetravelallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "leavetravelallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.leavetravelallowance
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Medical Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.medicalallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "medicalallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="medicalallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "medicalallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.medicalallowance?.amount ??
                          ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="medicalallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "medicalallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.medicalallowance?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Other Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.otherallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "otherallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="otherallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "otherallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.otherallowance?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="otherallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "otherallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.otherallowance?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Special Allowance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.specialallowance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "specialallowance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="specialallowance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "specialallowance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.specialallowance?.amount ??
                          ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="specialallowance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "specialallowance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.specialallowance?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Stipend</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.stipend?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "stipend",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="stipend-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "stipend",
                          "amount"
                        )}
                        value={this.state.salaryDetails?.stipend?.amount ?? ""}
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="stipend-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "stipend",
                          "remarks"
                        )}
                        value={this.state.salaryDetails?.stipend?.remarks ?? ""}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>Sub Total</td>
                    <td>₹{this.state.salaryDetails.subtotal}</td>
                  </tr>
                  <tr className="table-info">
                    <td colSpan={6}>Statutory Deduction</td>
                  </tr>
                  <tr>
                    <td>ESI Employee Contribution Manual</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails
                            ?.esiemployeecontributionmanual?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "esiemployeecontributionmanual",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="esiemployeecontributionmanual-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "esiemployeecontributionmanual",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails
                            ?.esiemployeecontributionmanual?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="esiemployeecontributionmanual-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "esiemployeecontributionmanual",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails
                            ?.esiemployeecontributionmanual?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>LWF Manual</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.lwfmanual?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "lwfmanual",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="lwfmanual-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "lwfmanual",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.lwfmanual?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="lwfmanual-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "lwfmanual",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.lwfmanual?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>TDS Manual</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.tdsmanual?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "tdsmanual",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="tdsmanual-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "tdsmanual",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.tdsmanual?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="tdsmanual-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "tdsmanual",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.tdsmanual?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr className="table-info">
                    <td colSpan={6}>Statutory Deduction</td>
                  </tr>
                  <tr>
                    <td>Non-Statutory Deduction</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.nonstatutorydeduction
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "nonstatutorydeduction",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="nonstatutorydeduction-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "nonstatutorydeduction",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.nonstatutorydeduction
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="nonstatutorydeduction-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "nonstatutorydeduction",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.nonstatutorydeduction
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Other Deduction</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.otherdeduction
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "otherdeduction",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="otherdeduction-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "otherdeduction",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.otherdeduction?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="otherdeduction-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "otherdeduction",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.otherdeduction?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Salary Advance</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.salaryadvance
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "salaryadvance",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="salaryadvance-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "salaryadvance",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.salaryadvance?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="salaryadvance-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "salaryadvance",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.salaryadvance?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr className="table-info">
                    <td colSpan={6}>Statutory Deduction</td>
                  </tr>
                  <tr>
                    <td>Company Contribution</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.companycontribution
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "companycontribution",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="companycontribution-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "companycontribution",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.companycontribution
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="companycontribution-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "companycontribution",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.companycontribution
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Employee ESI CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.employeeesictc
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "employeeesictc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="employeeesictc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeeesictc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.employeeesictc?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="employeeesictc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeeesictc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.employeeesictc?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Employee PF CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.employeepfctc
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "employeepfctc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="employeepfctc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeepfctc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.employeepfctc?.amount ?? ""
                        }
                        disabled={!this.state.salaryDetails?.employeepfctc?.manualedit}
                      />
                    </td>
                    <td></td>
                    <td>
                      <Switch
                        onChange={this.handleSwitchSalary.bind(
                          this,
                          "employeepfctc",
                          "manualedit"
                        )}
                        checked={
                          this.state.salaryDetails?.employeepfctc?.manualedit ??
                          false
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="employeepfctc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeepfctc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.employeepfctc?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Employer ESI CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.employeresictc
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "employeresictc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="employeresictc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeresictc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.employeresictc?.amount ?? ""
                        }
                        disabled={!this.state.salaryDetails?.employeresictc?.manualedit}
                      />
                    </td>
                    <td></td>
                    <td>
                      <Switch
                        onChange={this.handleSwitchSalary.bind(
                          this,
                          "employeresictc",
                          "manualedit"
                        )}
                        checked={
                          this.state.salaryDetails?.employeresictc
                            ?.manualedit ?? false
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="employeresictc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeresictc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.employeresictc?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Employee PF Admin Charges CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.employeepfadminchargescrc
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "employeepfadminchargescrc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="employeepfadminchargescrc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeepfadminchargescrc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.employeepfadminchargescrc
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="employeepfadminchargescrc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "employeepfadminchargescrc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.employeepfadminchargescrc
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Employer PF CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.cmployerpfctc
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "cmployerpfctc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="cmployerpfctc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "cmployerpfctc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.cmployerpfctc?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="cmployerpfctc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "cmployerpfctc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.cmployerpfctc?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Gratuity Contribution CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.gratuitycontributionctc
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "gratuitycontributionctc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="gratuitycontributionctc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "gratuitycontributionctc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.gratuitycontributionctc
                            ?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="gratuitycontributionctc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "gratuitycontributionctc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.gratuitycontributionctc
                            ?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Net Pay CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.netpayctc?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "netpayctc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="netpayctc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "netpayctc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.netpayctc?.amount ?? ""
                        }
                        disabled={!this.state.salaryDetails?.netpayctc?.manualedit}
                      />
                    </td>
                    <td></td>
                    <td>
                      <Switch
                        onChange={this.handleSwitchSalary.bind(
                          this,
                          "netpayctc",
                          "manualedit"
                        )}
                        checked={
                          this.state.salaryDetails?.netpayctc?.manualedit ??
                          false
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="netpayctc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "netpayctc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.netpayctc?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Prof Tax CTC</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.proftaxctc?.paybasics ?? {
                            label: "Monthly",
                            value: "M",
                          }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "proftaxctc",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="proftaxctc-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "proftaxctc",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.proftaxctc?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="proftaxctc-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "proftaxctc",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.proftaxctc?.remarks ?? ""
                        }
                      />
                    </td>
                  </tr>
                  <tr className="table-info">
                    <td colSpan={6}>Provision</td>
                  </tr>
                  <tr>
                    <td>Bonus Prevision</td>
                    <td>
                      <Select
                        value={
                          this.state.salaryDetails?.bonusprevision
                            ?.paybasics ?? { label: "Monthly", value: "M" }
                        }
                        onChange={this.handleSelectSalaryChange.bind(
                          this,
                          "bonusprevision",
                          "paybasics"
                        )}
                        placeholder="Select Pay Basis"
                        options={salarypay}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        placeholder="Amount"
                        name="bonusprevision-amount"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "bonusprevision",
                          "amount"
                        )}
                        value={
                          this.state.salaryDetails?.bonusprevision?.amount ?? ""
                        }
                      />
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Remarks"
                        name="bonusprevision-remarks"
                        onChange={this.handleChangeTextSalary.bind(
                          this,
                          "bonusprevision",
                          "remarks"
                        )}
                        value={
                          this.state.salaryDetails?.bonusprevision?.remarks ??
                          ""
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.openPopup("showSalaryPopup", false)}
            >
              Close
            </Button>
            <Button variant="primary" id="savesalary" onClick={this.saveSalary.bind(this)}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showpersonalInformationPopup}
          onHide={() => this.openPopup("showpersonalInformationPopup", false)}
          dialogClassName="modal-xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Personal Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label className="form-label">Father Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Father Name"
                  name="fatherName"
                  onChange={this.handleChangeText}
                  value={postdata?.fatherName ?? ""}
                  min={1}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Mother Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Mother Name"
                  name="MotherName"
                  onChange={this.handleChangeText}
                  value={postdata?.MotherName ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Marital Status</label>
                <Select
                  value={postdata?.maritalStatus ?? ""}
                  onChange={this.handleSelectChange.bind(this, "maritalStatus")}
                  placeholder="Select Marital Status"
                  isClearable={true}
                  options={maritalStatus}
                />
              </div>
              {postdata?.maritalStatus?.value === "Married" && (
                <div className="form-group col-md-4">
                  <label className="form-label">Marriage Date</label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control"
                    /* selected={postdata?.marriageDate ?? ''} */
                    dateFormat="dd/MM/yyyy"
                    onChange={this.handleChangeDate.bind(this, "marriageDate")}
                  />
                </div>
              )}
              <div className="form-group col-md-4">
                <label className="form-label">Personal EmailId</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Personal EmailId"
                  name="personalEmailId"
                  onChange={this.handleChangeText}
                  value={postdata?.personalEmailId ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Nominee Email</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nominee Email"
                  name="nomineeEmail"
                  onChange={this.handleChangeText}
                  value={postdata?.nomineeEmail ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Religion</label>
                <Select
                  value={postdata?.religion ?? ""}
                  onChange={this.handleSelectChange.bind(this, "religion")}
                  placeholder="Select Religion"
                  isClearable={true}
                  options={religionList}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Nationality</label>
                <Select
                  value={postdata?.nationality ?? ""}
                  onChange={this.handleSelectChange.bind(this, "nationality")}
                  placeholder="Select Nationality"
                  isClearable={true}
                  options={nationalityList}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Country Of Birth</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Country Of Birth"
                  name="countryOfBirth"
                  onChange={this.handleChangeText}
                  value={postdata?.countryOfBirth ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">State Of Birth</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="State Of Birth"
                  name="stateOfBirth"
                  onChange={this.handleChangeText}
                  value={postdata?.stateOfBirth ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Place Of Birth</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Place Of Birth"
                  name="placeOfBirth"
                  onChange={this.handleChangeText}
                  value={postdata?.placeOfBirth ?? ""}
                />
              </div>
              <div className="form-group col-md-2">
                <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="physicalDisabilities"
                    value="Yes"
                    onChange={this.handleChangeCheckbox}
                  />
                  <span className="custom-control-label">
                    Physical Disabilities
                  </span>
                </label>
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Disability Remark</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Disability Remark"
                  name="disabilityRemark"
                  onChange={this.handleChangeText}
                  value={postdata?.disabilityRemark ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">Identification Mark1</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Identification Mark1"
                  name="identificationMark1"
                  onChange={this.handleChangeText}
                  value={postdata?.identificationMark1 ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">PIdentification Mark2</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Identification Mark2"
                  name="identificationMark2"
                  onChange={this.handleChangeText}
                  value={postdata?.identificationMark2 ?? ""}
                />
              </div>
              <div className="form-group col-md-4">
                <label className="form-label">
                  Extra Curricular Interest / Hobbies
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Extra Curricular Interest / Hobbies"
                  name="extraCurricularInterest"
                  onChange={this.handleChangeText}
                  value={postdata?.extraCurricularInterest ?? ""}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() =>
                this.openPopup("showpersonalInformationPopup", false)
              }
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={this.savePersonalinfo.bind(this)}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.empformpost,
    detaildata: state.empdetaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_EMP_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_EMP_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(ViewDetails);
